import { useState } from "react";
import { uiIcons } from "../../assets/icons";
import GuideLogo from "../../assets/images/ui/gl-widget.png";
import ModalBase, { ModalType } from "../modals/ModalBase";
import { Checkbox, FormControlLabel } from "@mui/material";
import Walkthrough from "../walkthrough/Walkthrough";
import { googleAnalyticsCustomEvent } from "../../sharedUtilities/analytics";
import { NavModalTrigger, Button } from "@atlas-int/ui";
import styled from "@emotion/styled";

const GoldButton = styled(Button)`
  margin-top: 16px;
`;

const NotNowButton = styled(Button)`
  margin-top: 16px;
`;

const modalVersion = "0_1";
const localStorageKey = "localStorageFirstTimeGuideModalKey" + modalVersion;

export const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const GuideModalButton = ({
  menuOptionClassName,
  isNavigationBarOpen,
}: any) => {
  const initialCheckedValue = parseInt(
    localStorage.getItem(localStorageKey) as any,
    10,
  );
  const [runWalkthrough, setRunWalkthrough] = useState<boolean>(false);
  const [checked, setChecked] = useState<boolean>(false);

  const defaultOpen = isNaN(initialCheckedValue) || initialCheckedValue < 5;

  return (
    <>
      {runWalkthrough && <Walkthrough setRunWalkthrough={setRunWalkthrough} />}
      <NavModalTrigger
        icon={uiIcons.guide}
        iconAlt="Guide"
        label="Guide"
        isNavOpen={isNavigationBarOpen}
        menuOptionClassName={menuOptionClassName}
        defaultOpen={defaultOpen}
        onOpen={() =>
          googleAnalyticsCustomEvent("leftnav", "click", "guide", "explore")
        }
      >
        {({ isOpen, onClose }) => {
          const closeModal = () => {
            onClose();
            if (checked) {
              localStorage.setItem(localStorageKey, "5");
            } else {
              const newCheckedCount = isNaN(initialCheckedValue)
                ? 0
                : initialCheckedValue + 1;
              localStorage.setItem(localStorageKey, newCheckedCount.toString());
            }
          };

          const onStart = () => {
            onClose();
            localStorage.setItem(localStorageKey, "5");
            setRunWalkthrough(true);
          };

          return isOpen ? (
            <ModalBase
              modalType={ModalType.Generic}
              toggleModal={closeModal}
            >
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <img
                  style={{ width: "400px" }}
                  src={GuideLogo}
                  alt={"Growth Lab Logo"}
                />
                <GoldButton variant="gold" onClick={onStart}>
                  FOLLOW OUR STEP-BY-STEP GUIDE
                </GoldButton>
                <NotNowButton variant="default" onClick={closeModal}>
                  NOT NOW
                </NotNowButton>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={(event) => setChecked(event.target.checked)}
                      color="primary"
                    />
                  }
                  label="Don't Show Again"
                />
              </div>
            </ModalBase>
          ) : null;
        }}
      </NavModalTrigger>
    </>
  );
};

export default GuideModalButton;
